import { render, staticRenderFns } from "./order-details-tile.vue?vue&type=template&id=df8a0d38&"
import script from "./order-details-tile.vue?vue&type=script&lang=js&"
export * from "./order-details-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports